module.exports = __webpack_public_path__ + "img/advertising3.e26f7011.png";